import { PostalCode } from "../../../common-components/location/model/postal-code.model"
import { NodeAccountRequest } from "../../../../model/node/node-account-request.model"
import { AccountRequestRole } from "./account-request-role.model"
import { AccountRequestSchoolDistrict } from "./account-request-school-district.model"
import { PartyRoleAccountRequest } from "./party-role-account-request.model"
import { State } from "src/app/component/common-components/location/model/state.model"
import { City } from "src/app/component/common-components/location/model/city.model"

export class AccountRequest {
    ID?: number
    LAST_NAME?: string
    MIDDLE_INITIAL?: string
    FIRST_NAME?: string
    EMAIL_ADDRESS?: string
    ADDRESS_LINE_1?: string
    ADDRESS_LINE_2?: string
    CITIES_ID?: number
    STATES_ID?: number
    POSTAL_CODES_ID?: number
    TELEPHONE_NUMBER?: string
    TELEPHONE_NUMBER_EXT?: string
    WORK_TITLE?: string
    SIGNATURE?: string
    PREFIX?: string
    SUFFIX?: string
    EMAIL_CONFIRMATION_CODE?: string
    SUPERVISOR_FIRST_NAME?: string
    SUPERVISOR_LAST_NAME?: string
    SUPERVISOR_WORK_TITLE?: string
    SUPERVISOR_EMAIL_ADDRESS?: string
    SUPERVISOR_TELEPHONE_NUMBER?: string
    SUPERVISOR_TELEPHONE_NUMBER_EXT?: string
    CREATED_BY?: string
    CREATED_DATE?: Date
    MODIFIED_BY?: string
    MODIFIED_DATE?: Date

    ACCOUNT_REQUEST_ROLES?: AccountRequestRole[]
    CITy?: City
    POSTAL_CODES?: PostalCode
    STATE?: State
    PARTY_ROLE_ACCOUNT_REQUESTS?: PartyRoleAccountRequest[]
    NODE_ACCOUNT_REQUESTS?: NodeAccountRequest
    ACCOUNT_REQUEST_SCHOOL_DISTRICTS?: AccountRequestSchoolDistrict[]
}
